/* global google */
import { calculateZoomLevel } from './utils'

export default (container, bounds, options = {}) => {
  /**
   * Create a Google Map instance that's always
   * zoomed and centered on the given bounds.
   *
   * The created map doesn't allow manual scrolling,
   * zooming etc. by default.
   */

  const defaults = {
    disableDefaultUI: true,
    disableDoubleClickZoom: true,
    draggable: false,
    keyboardShortcuts: false,
    scrollwheel: false,
    center: bounds.getCenter(),
    zoom: calculateZoomLevel(
      bounds,
      container.offsetWidth,
      container.offsetHeight,
    ),
  }
  Object.keys(defaults).forEach((key) => {
    if (!(key in options)) options[key] = defaults[key]
  })

  const map = new google.maps.Map(container, options)
  const fitBounds = () => {
    map.setCenter(bounds.getCenter())
    map.setZoom(
      calculateZoomLevel(bounds, container.offsetWidth, container.offsetHeight),
    )
  }

  // Make the map resize when the container's window resizes
  container.ownerDocument.defaultView.addEventListener('resize', fitBounds)

  return map
}
